import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.645 9.5H5a1 1 0 0 0 0 2h4.645a3.502 3.502 0 0 0 6.71 0H27a1 1 0 1 0 0-2H16.355a3.502 3.502 0 0 0-6.71 0m1.855 1a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M5 20.5h12.645a3.502 3.502 0 0 1 6.71 0H27a1 1 0 1 1 0 2h-2.645a3.502 3.502 0 0 1-6.71 0H5a1 1 0 1 1 0-2m16-.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconSlidersHorizontal = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconSlidersHorizontal);
export default Memo;
